export default "__VITE_ASSET__B2WvxjNy__"